import React from 'react';

function ContactInfo() {
  return (
    <section className="flex-1">
      <h2 className="mb-10 text-4xl font-bold leading-tight text-teal-600 max-sm:text-3xl">
            Contact Information
      </h2>
      <div className="flex flex-col gap-8">
        <div className="flex gap-5 items-start">
            <div className="flex justify-center items-center w-12 h-12 bg-teal-600 rounded-lg flex-[shrink]">
                <i className="ti ti-mail text-2xl text-white" />
            </div>
            <div className="flex flex-col">
                <h3 className="mb-1 text-xl font-semibold leading-snug text-teal-600">
                Email
                </h3>
                <p className="text-base leading-relaxed text-gray-500">
                admin@kiosqu.id
                </p>
            </div>
        </div>
        <div className="flex gap-5 items-start">
            <div className="flex justify-center items-center w-12 h-12 bg-teal-600 rounded-lg flex-[shrink]">
                <i className="ti ti-phone text-2xl text-white" />
            </div>
            <div className="flex flex-col">
                <h3 className="mb-1 text-xl font-semibold leading-snug text-teal-600">
                Phone / Whatsapp
                </h3>
                <p className="text-base leading-relaxed text-gray-500">
                    <a
                        href="https://wa.me/6287870162765"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-base leading-relaxed text-gray-500 hover:text-green-600"
                    >+62 (878) 7016-2765</a>
                </p>
            </div>
        </div>
      </div>
    </section>
  );
}

export default ContactInfo;
